import { createSlice } from "@reduxjs/toolkit";
import { set } from "lodash";

const walletSlice = createSlice({
  name: "usersound",
  initialState: {
    sound: null, // Default value
  },
  reducers: {
    SetSound: (state, action) => {
      state.sound = action.payload;
    },
   
  },
});

export const { SetSound } = walletSlice.actions;
export default walletSlice.reducer;